//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: String,
    elevation: {
      type: String,
      default: '0',
    },
    color: {
      type: String,
      default: undefined,
    },
    subtitle: {
      type: String,
      default() { return this.$t('label.preencha_campos_abaixo'); },
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    save: {
      type: Function,
      default() { return () => ({}); },
    },
    cancel: {
      type: Function,
      default() { return () => ({}); },
    },
    cancelLabel: {
      type: String,
      default() {
        return this.$t('label.cancelar');
      },
    },
    saveLabel: {
      type: String,
      default() {
        return this.$t('label.salvar');
      },
    },
    showButton: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    cancelAction() {
      if (this.cancel) {
        this.cancel();
      }
      this.$emit('REGISTERFORM_CANCEL_ACTION');
    },
    saveAction() {
      if (this.save) {
        this.save();
      }
      this.$emit('REGISTERFORM_SAVE_ACTION');
    },
  },
};



// WEBPACK FOOTER //
// ./src/shared-components/generico/RegisterForm.vue?vue&type=script&lang=js&